<template>
  <ion-page>
    <Background></Background>
    <WhiteBackground></WhiteBackground>
    <FabColumn>
      <AboutButton back_url="SurveyFinish"></AboutButton>
    </FabColumn>

    <ion-content>
      <div class="flow-content">
      <div v-if="test_advice_type == '需要關注'" class="main">
        <MainTitle text="立即關注腦部健康" style="margin-bottom: 4vh;"></MainTitle>
        <div class="scroll-box enable-scroll" style="flex-grow: 1;">
          <MainDescribe text="謝謝您參加「中大網上認知測試」，你的測試結果為需要關注。"></MainDescribe>
          <div v-if="follow_up_is_wish == true">
            <MainDescribe text="以下機構將會進一步與您聯絡："></MainDescribe>
            <MainDescribe :text="'機構名稱：' + user_info.ngo_name"></MainDescribe>
            <MainDescribe :text="'地址：' + user_info.ngo_address"></MainDescribe>
            <MainDescribe :text="'電話：' + user_info.ngo_phone"></MainDescribe>
          </div>
          <br>
          <MainDescribe text="歡迎瀏覽賽馬會「智康健」腦退化檢測及社區支援計劃網站或腦退化症網上學習平台學習更多腦退化症知識。"></MainDescribe>
          <br>
          <MainDescribe text="賽馬會「智康健」腦退化檢測及社區支援計劃"></MainDescribe>
          <MainDescribe href="https://www.jccpa.org.hk/projects/dscs"></MainDescribe>
          <br>
          <MainDescribe text="腦退化症網上學習平台"></MainDescribe>
          <MainDescribe href="https://edu.jccpa.org.hk"></MainDescribe>
        </div>
      </div>
      <div v-else class="main">
        <MainTitle text="腦部健康小貼士" style="margin-bottom: 4vh;"></MainTitle>
        <div class="scroll-box enable-scroll" style="flex-grow: 1;">
          <MainDescribe text="謝謝您參加「中大網上認知測試」，你的測試結果為合格。"></MainDescribe>
          <MainDescribe text="歡迎瀏覽賽馬會耆智園網站" href="https://www.jccpa.org.hk/about-dementia/brain-health-tips"
            text_2="學習更多健腦知識。"></MainDescribe>
          <br>
          <MainDescribe text="其他參考網站︰"></MainDescribe>
          <br>
          <MainDescribe text="賽馬會「智康健」腦退化檢測及社區支援計劃"></MainDescribe>
          <MainDescribe href="https://www.jccpa.org.hk/projects/dscs"></MainDescribe>
          <br>
          <MainDescribe text="腦退化症網上學習平台"></MainDescribe>
          <MainDescribe href="https://edu.jccpa.org.hk"></MainDescribe>
          <br>
          <MainDescribe text="周佩芳認知障礙預防研究中心"></MainDescribe>
          <MainDescribe href="https://cog.mect.cuhk.edu.hk"></MainDescribe>
        </div>
      </div>
      <ConfirmButton class="flow-confirm-button" text="完成" position="relative" @click="goNext"></ConfirmButton>
      <TestNumber :number="user_info.number"></TestNumber>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonContent, IonPage } from "@ionic/vue";
import Background from "../components/common/Background";
import WhiteBackground from "../components/common/WhiteBackground";
import MainTitle from "../components/common/MainTitle";
import MainDescribe from "../components/common/MainDescribe";
import ConfirmButton from "../components/common/ConfirmButton";
import router from "../router";
import AboutButton from "@/components/common/AboutButton";
import common from "@/common";
import TestNumber from "@/components/test/TestNumber";

export default {
  name: "SurveyFinish",
  components: {
    TestNumber,
    AboutButton,
    ConfirmButton,
    MainDescribe,
    MainTitle,
    WhiteBackground,
    Background,
    IonPage,
    IonContent
  },
  data() {
    return {
      test_advice_type: '',
      follow_up_is_wish: false,
      user_info: {}
    }
  },
  ionViewWillEnter() {
    common.getStorage('user_info').then(user_info => {
      this.user_info = user_info
      common.getStorage('result_' + user_info.id).then(result => {
        this.test_advice_type = result.advice_type;
      })

      common.getStorage('followUp_' + user_info.id).then(is_wish => {
        if (is_wish) {
          this.follow_up_is_wish = is_wish;
        }

      })
    })
  },
  methods: {
    goNext: function () {
      common.getStorage('staff').then(staff => {
        if (!staff) {
          router.replace('/credit')
        } else {
          router.replace('/NgoDataEntry')
        }
      })

    }
  }
}
</script>

<style scoped>
.main {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.flow-confirm-button :deep(.relative) {
  margin: clamp(0.75rem, 2vw, 1.25rem) auto 0;
}
</style>
